/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDownRabbitHole32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='#fff'
        fillOpacity={0.5}
        fillRule='evenodd'
        d='M16.558 24.998h4.672c.09 0 .172.056.21.133a.234.234 0 01-.035.248 9420.34 9420.34 0 00-5.523 6.445.193.193 0 01-.152.066.193.193 0 01-.152-.067c-.787-.921-4.41-5.147-5.523-6.444a.235.235 0 01-.034-.248.25.25 0 01.088-.097.225.225 0 01.122-.036h4.672V0h1.655v24.998z'
      />
    </svg>
  );
}

export default SvgDownRabbitHole32;
